import * as React from "react";
import { withTranslation } from "react-i18next";
import styled from "styled-components";
import { Modal, Button } from "react-bootstrap";
import moment from "moment";

import LoadingAnim from "../LoadingAnim/ThreeDots";
import Calendar from "../Calendar";

const DateSwitcher = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  font-size: 18px;
  margin-bottom: 20px;
`;
const DatesArrow = styled.span`
  ${(props) =>
    props.isDisabled
      ? ` margin-left: 10px;
    margin-right: 10px;
    cursor: not-allowed;
    color: #969696;
  `
      : ` margin-left: 10px;
    margin-right: 10px;
    cursor: pointer;
    color: #000;
  `}
`;
const DateName = styled.span`
  margin-left: 10px;
  margin-right: 10px;
  color: #000;
  cursor: ${(props) => (props.pointer ? "pointer" : "default")};
`;

const LoadingDots = styled(LoadingAnim)`
  margin-bottom: 2em;
`;

class CalendarGeneralModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
      maxDate: moment(),
      nextDataDateString: props.formatDateToString(props.date),
    };
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.date.isSame(this.props.date)) {
      this.setState({
        nextDataDateString: this.props.formatDateToString(this.props.date),
      });
    }
  }

  handleShowModal = () => {
    if (
      this._isMounted &&
      this.state.nextDataDateString ===
        this.props.formatDateToString(this.props.date)
    ) {
      this.setState({ isVisible: true });
    }
  };

  handleHideModal = () => {
    if (this._isMounted) {
      this.setState({ isVisible: false });
    }
  };

  handleNewDate = (newDate, disabled = false) => {
    if (this._isMounted && !disabled) {
      const { loadDataForSystem, date, formatDateToString } = this.props;

      if (!newDate.isSame(date)) {
        this.setState(
          { nextDataDateString: formatDateToString(date), isVisible: false },
          () => loadDataForSystem(newDate, disabled),
        );
        return;
      }

      this.handleHideModal();
    }
  };

  renderDateName = (isLoading) => {
    const { formatDateToString, date } = this.props;
    const handleClick = isLoading ? () => {} : this.handleShowModal;

    return (
      <DateName pointer={!isLoading} onClick={handleClick}>
        {formatDateToString(date)}
        {isLoading ? <LoadingDots /> : null}
      </DateName>
    );
  };

  render() {
    const { t, i18n, date, formatDateToString, maxDetail, interval } =
      this.props;

    const { isVisible, nextDataDateString, maxDate } = this.state;

    const direction = i18n.dir();
    const disabledNextDate = maxDate.isSame(date, interval);
    const disabledPrevDate = false;
    const isLoading = formatDateToString(date) !== nextDataDateString;

    // set first day of week and weekends
    const calendarType = direction === "rtl" ? "Hebrew" : "ISO 8601";

    return (
      <>
        <DateSwitcher>
          <DatesArrow
            isDisabled={disabledPrevDate}
            onClick={() =>
              this.handleNewDate(
                moment(date).subtract(1, interval),
                disabledPrevDate,
              )
            }
          >
            {"<"}
          </DatesArrow>
          {this.renderDateName(isLoading)}
          <DatesArrow
            isDisabled={disabledNextDate}
            onClick={() =>
              this.handleNewDate(
                moment(date).add(1, interval),
                disabledNextDate,
              )
            }
          >
            {">"}
          </DatesArrow>
        </DateSwitcher>
        <Modal show={isVisible} onHide={this.handleHideModal} bsSize="small">
          <Modal.Body>
            <Calendar
              shouldRender={isVisible}
              maxDate={maxDate.toDate()}
              value={date.toDate()}
              onChange={(newDate) => this.handleNewDate(moment(newDate))}
              calendarType={calendarType}
              maxDetail={maxDetail}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.handleHideModal}>{t("Cancel")}</Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

export default withTranslation()(CalendarGeneralModal);
